import React, { useState } from 'react';
import { object, string, mixed } from 'yup';
import propTypes from 'prop-types';

import Review from '../ReviewPage/Review';
import { FormStepper } from '../FormStepper';
import { BasicDetails } from '../Steps/BasicDetails';
import { QuestionDetails } from '../Steps/QuestionDetails';
import { PanelDetails } from '../Steps/PanelDetails';
import RichWebPageSetup from '../Steps/RichWebPageSetup';
import { PostExposureSurvey } from '../Steps/PostExposureSurveyDetails';
import { ScreeningSurvey } from '../Steps/ScreeningSurveyDetails';
import { useSelector } from 'react-redux';


export default function DigitalRichStepper({
  onAddNewStudySubmit,
  environmentData,
  locationTypes,
  languageTypes,
  questionTypes,
  brandTypes,
  respondentTypes,
  defaultValues,
  basicDetailsValidationSchema,
  panelDetailsValidationSchema,
  questionDetailsValidationSchema,
  screeningSurveyValidationSchema,   
  postExposureValidationSchema, 
  history,
}) {

  const [stepImperatively, setStepImperatively] = useState(null);

      const companyUsersRaw = useSelector((state) => state.studyData.companyUsers);
      const loggedInUser = useSelector((state) => state.userData.userData);
      
      const safeUsers = Array.isArray(companyUsersRaw)
        ? companyUsersRaw
        : Array.isArray(companyUsersRaw?.data)
          ? companyUsersRaw.data
          : [];
      
      const userOptions = safeUsers.map((u) => ({
        id: u.user_id || u.id,
        name: u.first_name && u.last_name
          ? `${u.first_name} ${u.last_name}`
          : u.name || u.username,
        description: u.email || "",
      }));
  
  return (
    <FormStepper
      stepImperatively={stepImperatively}
      setStepImperatively={setStepImperatively}
      initialValues={{
        ...defaultValues,
        panel_seconds_before_move_next: -1,
        number_of_cells: 1,
        incontext_primary_site: '',
        stim_script: '',
        incontext_distraction_site: '',
        brand_id: null,
        study_type_id: 7,
        override_owner_id: loggedInUser?.user_id || null,

      }}
      onSubmit={async (values) => {
        await onAddNewStudySubmit(values, history);
      }}
    >
      <BasicDetails
        title='Tell us about your study'
        label='Basic Details'
        validationSchema={basicDetailsValidationSchema}
        showCellsSlider = {false}
        
        {...{
          environmentData,
          locationTypes,
          languageTypes,
          respondentTypes,
          userOptions,
        }}
      />
      {/* <QuestionDetails
        validationSchema={questionDetailsValidationSchema}
        title='What surveys will you use?'
        label='Question Details'
        {...{questionTypes}}
      /> */}
      <ScreeningSurvey
        title="What screening survey will you use?"
        label="Screening Survey"
        validationSchema={screeningSurveyValidationSchema}
        {...{ questionTypes }}
      />
      <PanelDetails
        validationSchema={panelDetailsValidationSchema}
        title='Tell us about your recruitment'
        label='Panel Details'
      />
      <RichWebPageSetup
        validationSchema={object().shape({
          incontext_primary_site: string()
            .url('Must be a valid URL')
            .max(512, 'Too Long!')
            .required('Required'),
          stim_script: string()
            .max(3000, 'Too Long!')
            .required('Required'),
          incontext_distraction_site: string()
            .url('Must be a valid URL')
            .max(512, 'Too Long!')
            .required('Required'),
          brand_id: mixed().required('Required'),
        })}
        title={`Great! Now let's setup your page`}
        label='Web Page Setup'
        {...{brandTypes}}
      />
      <PostExposureSurvey
        title="What post-exposure survey will you use?"
        label="Post Exposure Survey"
        validationSchema={postExposureValidationSchema}
      />

      <Review
        title='Your project is ready for review'
        label='Review'
        setStepImperatively={setStepImperatively}
        labels={[
          'Basic Details',
          'Question Details',
          'Panel Details',
          'Cache Page Setup',
        ]}
      />
    </FormStepper>
  );
}

DigitalRichStepper.propTypes = {
  onAddNewStudySubmit: propTypes.func,
  languageTypes: propTypes.object,
  environmentData: propTypes.object,
  locationTypes: propTypes.object,
  questionTypes: propTypes.object,
  brandTypes: propTypes.object,
  respondentTypes: propTypes.object,
  defaultValues: propTypes.object,
  basicDetailsValidationSchema: propTypes.object,
  panelDetailsValidationSchema: propTypes.object,
  questionDetailsValidationSchema: propTypes.object,
  history: propTypes.object,
};
